// Colors sourced from the project's existing Tailwind palette (tailwind.config.js)
// purple.DEFAULT, sky.500, emerald.DEFAULT, yellow.DEFAULT, blue.500,
// orange.300, orange.600, seagreen.500, indigo.800, gray.600, purple.200
const COMCAST_CHART_COLOR_FALLBACKS = [
  '#8781FF', // purple.DEFAULT
  '#3DD8F2', // sky.500
  '#61F29D', // emerald.DEFAULT
  '#FFEB40', // yellow.DEFAULT
  '#4A89FF', // blue.500
  '#FF7657', // orange.300
  '#EF4732', // orange.600
  '#20B2AA', // seagreen.500
  '#17328D', // indigo.800
  '#8793A2', // gray.600
  '#A5A1FF', // purple.200
] as const;

const COMCAST_CHART_COLOR_VARIABLES = COMCAST_CHART_COLOR_FALLBACKS.map(
  (_, index) => `--comcast-chart-${index + 1}`,
);

function resolveCssVariableColor(
  variableName: string,
  fallback: string,
): string {
  if (typeof document === 'undefined') {
    return fallback;
  }

  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(variableName)
    .trim();

  return value || fallback;
}

export function getComcastChartPalette(): string[] {
  return COMCAST_CHART_COLOR_VARIABLES.map((variableName, index) =>
    resolveCssVariableColor(variableName, COMCAST_CHART_COLOR_FALLBACKS[index]),
  );
}

export function getComcastChartColorByIndex(
  index: number,
  palette = getComcastChartPalette(),
): string {
  return palette[((index % palette.length) + palette.length) % palette.length];
}
